import { render } from "./TelemedicineContentPtBR.vue?vue&type=template&id=02e1512d&scoped=true"
import script from "./TelemedicineContentPtBR.vue?vue&type=script&lang=js"
export * from "./TelemedicineContentPtBR.vue?vue&type=script&lang=js"

import "./TelemedicineContentPtBR.vue?vue&type=style&index=0&id=02e1512d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02e1512d"]])

export default __exports__